<input
    nz-input
    [ngModel]="value"
    (ngModelChange)="onModelChange($event)"
    [readOnly]="readonly"
    (keydown)="onKeydown($event)"
    [class]="readonly && !borderless ? 'bg-grey-lighter' : ''"
    maxlength="16"
    (click)="onClick($event.target)"
/>